import type {
  GetIndicatorsParams,
  IndicatorType,
} from "$/lib/types/api/market-monitoring/market-monitoring.types";
import { restApiClient } from "../restApiClient";

export const getLatestInputDate = async () => {
  return restApiClient
    .url("/market-monitoring/latest-input-date")
    .get<{ futureLatestDate: string; spotLatestDate: string }>();
};

export const getIndicatorByDate = async (params: GetIndicatorsParams) => {
  return restApiClient
    .url("/market-monitoring/unique-indicator")
    .query({ ...params })
    .get<IndicatorType>();
};
